import React from "react"
import TermsAndConditions from "../assets/imgs/t&c.jpg"

const TermsConditions = () => {
    return (
        <>
            <main id="main">
                <section id="breadcrumbs" className="d-flex align-items-center" style={{ background: `url(${TermsAndConditions})`, backgroundSize: "cover" }}>
                    <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
                        <h1 className="pt-3">Terms and Conditions</h1>
                    </div>
                </section>
                <section id="termsandconditions" className="termsandconditions" style={{ paddingTop: "0", paddingBottom: "0" }}>
                    <div className="container p-3 p-lg-5 pt-2">
                        <div className="section-title" data-aos="fade-up">
                            <h2 className="pt-3">Our Terms and Conditions</h2>
                        </div>
                        <div className="lg:pt-[60px] lg:pb-[60px] pb-[180px]">
                            <div className="theme-container mx-auto">
                                <div className="body-content-wrapper lg:col-span-8 mb-10 lg:mb-0">
                                    <div className="grid items-center">
                                        <div className="article-area">
                                            <p className="sm:text-sm sm:leading-8 text-sm font-bold spline-sans text-white mb-5">
                                                <strong>Last Updated: 29th January, 2026</strong>
                                            </p>
                                            <p className="text-base leading-[27px] text-white mb-[20px]">
                                                By accessing Fintrek Marketing’s website, you agree to these
                                                terms. If you do not agree, please discontinue use.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Services</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                Fintrek Marketing provides various financial services, including
                                                loans, credit cards, and insurance solutions. Services are
                                                subject to eligibility and approvals.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>User Responsibilities</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                Users must provide accurate information when using Fintrek
                                                Marketing services. Misuse of services or fraudulent activity
                                                may result in service termination and legal action.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Limitation of Liability</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                Fintrek Marketing is not liable for any financial loss resulting 
                                                from the use of its services. Financial decisions remain the 
                                                user’s responsibility.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Governing Law</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                These terms are governed by the laws of the United Arab Emirates. 
                                                Any disputes will be handled under UAE law.
                                            </p>

                                            <p className="items-center pb-[5px] pt-4">
                                                <span className="custom-heading">
                                                    <strong>Contact Us</strong>
                                                </span>
                                            </p>
                                            <p className="custom-content">
                                                For any inquiries about our Terms and Conditions, please contact us at
                                                <strong> about@fintrekmarketing.com </strong> or <strong> +971 449 03500</strong>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </main>
        </>
    )
}

export default TermsConditions